import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-modal-formulario-coaf',
  templateUrl: './modal-formulario-coaf.component.html',
  styleUrls: ['./modal-formulario-coaf.component.css']
})
export class ModalFormularioCoafComponent {
  @Input() id!: number;
  @Input() positions!: any[];
  constructor(public activeModal: NgbActiveModal) { }
  selectJob(id: any) {
    this.activeModal.close(id);
  }
}
